export default function numberToUSD(num) {
  return "$" + Number(num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}